import { ActionTree } from 'vuex';
import ApiUrl from '../../../../api/url';
import { NodeNodeLoginHistoryExcludeConditionState } from './types';
import { RootState } from '../../../types';
import * as types from './mutation-types';
import { AppContext } from '../../../context';
const MessageKey = AppContext.MessageKey;
import { translator } from '../../../translator';
import { isHappenedOtherPartyError } from '../../../error-type';

export const actions: ActionTree<NodeNodeLoginHistoryExcludeConditionState, RootState> = {
    /**
     * ノード紐付きログイン履歴収集除外条件一覧取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} id ノードID
     * @param {any} pageNumber ページ番号
     * @param {any} perPage ページ毎の表示件数
     * @returns {Promise<void>}
     */
    async search({ dispatch, commit }, { id, pageNumber, perPage, sort } = {}) {
        const requestParams = {
            page_number: pageNumber,
            per_page: perPage,
            'sort[column]': sort.column,
            'sort[direction]': sort.direction,
        };
        const nodeId = id;
        try {
            commit(types.SEARCH_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.Node.NodeLoginHistoryExcludeCondition.INDEX.replace(':id', nodeId.toString()),
                    params: requestParams,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SEARCH_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SEARCH_FAILURE, resData.errors[0]);
        }
    },

    /**
     * 画面切り替え時のstoreの消去
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute({ commit }) {
        commit(types.CLEAR_ALL);
    },
};
